import React from "react";
import style from "../../../styles/landing.module.scss";

// Sección de la landing con etiqueta, título (h2) y subtítulo; el contenido va en children
const SeccionLandingComponent = ({ id, etiqueta, titulo, subtitulo, styleGroup = "", children }) => {
    return (
        <section id={id} className={`${style.seccion} ${styleGroup}`} aria-labelledby={`${id}-titulo`}>
            {etiqueta && <p className={style.etiqueta}>{etiqueta}</p>}
            <h2 id={`${id}-titulo`} className={style.seccion_titulo}>{titulo}</h2>
            {subtitulo && <p className={style.seccion_subtitulo}>{subtitulo}</p>}
            {children}
        </section>
    );
};

export default SeccionLandingComponent;
